import script from "./org-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./org-form.vue?vue&type=script&lang=ts&setup=true"

import "./org-form.vue?vue&type=style&index=0&id=010f8f44&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010f8f44"]])

export default __exports__